import { z } from 'zod';

import { shared } from '@tig-dpqa-cloud/contract-backend-common';

export const slideScanBucketCredentials = z.object({
  credentials: shared.BucketCredentials,
});

export type SlideScanBucketCredentials = z.infer<typeof slideScanBucketCredentials>;
